import { useMutation } from "@tanstack/react-query";
import { usePrimaryAPIClient } from "../context/PrimaryAPIClient";

export const useValidateLocalAccount = () => {
    const { registrationApi } = usePrimaryAPIClient();

    return useMutation({
        mutationFn: (email: string) => {
            return registrationApi.validateLocalAccountPost({
                validateLocalAccountRequest: {
                    email,
                },
            });
        },
    });
};